import React from 'react';
import imgVirgen from '../assets/img/virgen.jpg';

export default function PedidosOracion() {
  return (
    <>
      <div className="container-fluid pt-3">
        <img src={imgVirgen} alt="Imagen Pedido" id="top" className="w-100 pt-5" />
      </div>
      <div className="container">
        <div className="row">
          <form className="py-5">
            <div className="form-floating mb-3">
              <input type="text" className="form-control" id="inputNombre" placeholder="Nombre completo" />
              <label>Nombre</label>
            </div>
            <div className="form-floating">
              <textarea className="form-control" style={{ height: 'auto' }} rows={3} placeholder="Escribe tu Pedido de Oración" id="inputPedido"></textarea>
              <label>Escribe tu Pedido de Oración</label>
            </div>
            <div className="mt-3">
              <button type="submit" className="btn btn-fundacion">Enviar</button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
